import { render, staticRenderFns } from "./ManagePrintProperties.vue.js?vue&type=template&id=84b83edc&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManagePrintProperties.vue?vue&type=template&id=84b83edc&scoped=true"
import script from "./ManagePrintProperties.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManagePrintProperties.vue?vue&type=script&lang=js"
export * from "./ManagePrintProperties.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManagePrintProperties.vue?vue&type=script&lang=js"
import style0 from "./ManagePrintProperties.vue.scss?vue&type=style&index=0&id=84b83edc&prod&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManagePrintProperties.vue?vue&type=style&index=0&id=84b83edc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b83edc",
  null
  
)

export default component.exports